<template>
  <div>
    <v-card v-if="product">
      <v-card-title class="subheading font-weight-bold">
        {{ product.name }}
      </v-card-title>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item>
          <v-list-item-content>Total Received:</v-list-item-content>
          <v-list-item-content class="align-end">
            {{ inventory.quantity_received }}
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>Total Sold:</v-list-item-content>
          <v-list-item-content class="align-end">
            {{ inventory.quantity_sold }}
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>Stock Available:</v-list-item-content>
          <v-list-item-content class="align-end">
            {{ inventory.quantity_in_stock }}
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>Amount Received:</v-list-item-content>
          <v-list-item-content class="align-end">
            {{ getCurrency + formatMoney(inventory.amount_received) }}
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>Amount Sold:</v-list-item-content>
          <v-list-item-content class="align-end">
            {{ getCurrency + formatMoney(inventory.amount_sold) }}
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>Stock Amount:</v-list-item-content>
          <v-list-item-content class="align-end">
            {{ getCurrency + formatMoney(inventory.amount_in_stock) }}
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";

export default {
  props: {
    productProp: {
      default: null,
    },
  },
  computed: {
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
  },
  mounted() {
    this.setProduct(this.productProp);
  },
  watch: {
    productProp(newVal) {
      this.setProduct(newVal);
    },
  },
  data: () => ({
    product: null,
    inventory: null,
  }),
  methods: {
    setProduct(product) {
      this.product = product;
      this.inventory = product.inventory;
    },
    formatMoney(amount) {
      return helpersJs.formatMoney(amount);
    },
  },
};
</script>
